import { getAssetUrl } from '@/shared/lib/cdn'
import { useI18n } from '@/shared/lib/i18n'
import { BackgroundImage } from '@/shared/ui'

import { playUiAssets } from './assets'
import { gameOverlayRecipe } from './recipe'

export function LoginFail() {
    const { i18n } = useI18n()
    const styles = gameOverlayRecipe()

    return (
        <BackgroundImage src={playUiAssets.overlayBackground} className={styles.overlay}>
            <img src={getAssetUrl(playUiAssets.bunny)} alt="Failed to login. Try again later" />
            <BackgroundImage src={playUiAssets.bubbleBackground} className={styles.bubble}>
                <p className={styles.bubbleText} dangerouslySetInnerHTML={{ __html: i18n.TEXT_systemLoginFail }} />
            </BackgroundImage>
        </BackgroundImage>
    )
}
